import { render } from "./upload_vdo.vue?vue&type=template&id=12ea3776&scoped=true"
import script from "./upload_vdo.vue?vue&type=script&lang=js"
export * from "./upload_vdo.vue?vue&type=script&lang=js"

import "./upload_vdo.vue?vue&type=style&index=0&id=12ea3776&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ea3776"]])

export default __exports__